{
  "back": "Volver",
  "badge": "Verificación oficial",
  "title": "Validación de certificado",
  "subtitle": "Ingresa el código (hash) del certificado para confirmar su autenticidad y ver el documento.",
  "search": {
    "placeholder": "Pega el código del certificado",
    "submit": "Validar"
  },
  "revoked": {
    "title": "Certificado revocado",
    "subtitle": "Este certificado ha sido revocado y ya no es válido."
  },
  "notFound": {
    "title": "Certificado no encontrado",
    "subtitle": "Verifica el código e inténtalo de nuevo.",
    "requestFailed": "No se pudo validar el código"
  },
  "footer": "Xtreed · Plataforma de enseñanza",
  "valid": {
    "title": "Certificado auténtico",
    "subtitle": "Emitido oficialmente por la plataforma.",
    "student": "Alumno",
    "content": "Contenido",
    "issuedAt": "Emitido el",
    "code": "Código"
  },
  "preview": {
    "fileName": "certificado-{{code}}.png",
    "iframeTitle": "Vista previa del certificado",
    "view": "Ver certificado",
    "download": "Descargar"
  }
}
